import { useAuthentication, EXTERNAL_LINKS } from '@psyomics/ui-common';
import { AppBar, LoadingSpinner } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

function SecureLayout() {
  const { isAuthenticated, logout, organisation, isLoading, bulkReferralEnabled } = useAuthentication();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isLoading && !isAuthenticated) {
    throw new Error('User is not authenticated');
  }

  const menuItems = [
    {
      id: 'home',
      label: t('navigation.home'),
      onClick: () => navigate(`/account/${organisation}/home`),
    },
    {
      id: 'activityDashboard',
      label: t('page.clinicianHomepage.menu.activityDashboard'),
      onClick: () => navigate(`/account/${organisation}/home/activity-dashboard`),
    },
    {
      id: 'clinicalReports',
      label: t('page.clinicianHomepage.menu.clinicalReports'),
      onClick: () => navigate(`/account/${organisation}/home/referrals`),
    },
    ...(bulkReferralEnabled
      ? [
          {
            id: 'referralUploadJobs',
            label: t('page.clinicianHomepage.menu.referralUploadJobs'),
            onClick: () => navigate(`/account/${organisation}/home/bulk-referral-uploads`),
          },
        ]
      : []),
    {
      id: 'ifu',
      label: t('page.clinicianHomepage.menu.instructionsForUse'),
      onClick: () => {
        const newWindow = window.open(EXTERNAL_LINKS.INSTRUCTIONS_FOR_USE, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
      },
    },
    {
      id: 'signout',
      label: t('page.clinicianHomepage.menu.signOut'),
      onClick: () => logout('logged-out', { ...(organisation ? { loggedOutOrgCode: organisation } : {}) }),
    },
  ];

  return (
    <div className="flex min-h-dvh flex-col">
      <AppBar menuItems={menuItems} />
      <main className="flex min-h-0 flex-1 flex-col">{isLoading ? <LoadingSpinner /> : <Outlet />}</main>
    </div>
  );
}
export { SecureLayout };
